// "See it. Snap it. Share it." (or "See. Snap. Share." for guests)
import React from "react";

export const Slogan = ({ size = "lg", compact = false, className = "" }) => {
  const wordSize = {
    lg: "text-3xl sm:text-4xl",
    md: "text-xl",
    sm: "text-lg",
  }[size];
  const weight = compact ? "font-bold" : "font-light";
  const periods = compact ? ["See.", "Snap.", "Share."] : ["See it.", "Snap it.", "Share it."];
  const colors = ["slogan-violet", "slogan-cyan", "slogan-coral"];

  return (
    <div className={`flex flex-wrap items-baseline justify-center gap-x-2 gap-y-1 ${className}`} data-testid="slogan">
      {periods.map((word, i) => (
        <span key={i} className={`${wordSize} ${weight} ${colors[i]} tracking-tight`}>
          {word}
        </span>
      ))}
    </div>
  );
};
